/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Pxk_Items_TitleInputs */

const vi_orders_pxk_items_title = /** @type {(inputs: Orders_Pxk_Items_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hàng trong phiếu (${i?.count})`)
};

/**

* @param {Orders_Pxk_Items_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const orders_pxk_items_title = /** @type {((inputs: Orders_Pxk_Items_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pxk_Items_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_orders_pxk_items_title(inputs)
});